<!--
Author: TangChen
Date: 2018-10-17
Desc: 修改交易密码密码页面，由index.js 配置引入
 -->
<template>
    <div>
        <div :class="'bizcomp-change-tpwd bizcomp ' + className">
            <change-pwd :way="way" />
        </div>
        <footer-questions :warning-html="warningHtml"></footer-questions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import changePwd from "@/components/acctInfo/changePwdDc.vue";
import footerQuestions from "@/components/layout/footerQuestions.vue";

export default {
    name: "ChangeTpwd",
    components: {
        changePwd,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            way: "trade",
            warningHtml: ""
        };
    },
    mounted() {
        this.warningHtml = `亲爱的中银易商用户，请下载${
            this.$const.COMPANY
        }基金APP完成相关操作，官网、微信不支持该项服务，给您带来的不便深表歉意。您可以拨打${
            this.$const.COMPANY
        }基金客服热线进行咨询：${this.$cache.getCompanyInfoParam("10101009")}`;
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-change-tpwd {
}
</style>
